
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UpdatesService from '_services/updates-service';


export const getPosts = createAsyncThunk('notifications/getPosts', async (userId) => {
  return await UpdatesService.getPosts();
});

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  posts: {}
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.posts = action.payload;
      })
      .addCase(getPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


  },
});

export default notificationsSlice.reducer;

// Selector to get the pairs of questions and answers
export const selectPosts = (state) => {
  if (state.notifications.posts === undefined) {
    return {};
  }

  const posts = state.notifications.posts;
  const reversedPosts = {};

  // Get the keys of the original object and reverse them
  const keys = Object.keys(posts).reverse();

  // Populate the reversedPosts object with the reversed keys and original values
  for (const key of keys) {
    reversedPosts[key] = posts[key];
  }

  return reversedPosts; // Return the object with reversed keys
};


export const selectUnseenPosts = (date) => (state) => {
  let dates = Object.keys(state.notifications.posts).map((key) => key.replace('.md', ''));
  // check if there is a date in dates greater than date 
  for (let i = 0; i < dates.length; i++) {
    if (dates[i] > date) {
      return true;
    }
  }
  return false
}
// export const selectQALoading = (state) => state.qa.loading;
// export const selectQAError = (state) => state.qa.error;
// export const selectQuestion = (state) => state.qa.question;
// export const selectAnswer = (state) => state.qa.answer;

export const { reset } = notificationsSlice.actions;
